import { ArrowRight, TicketPercent } from "lucide-react";
import { Link } from "react-router";
import { posthog } from "../../lib/posthog";

type PromoOfferProps = {
  location: string;
  variant?: "banner" | "card";
};

export function PromoOffer({ location, variant = "card" }: PromoOfferProps) {
  const track = () => posthog.capture("cta_clicked", { cta: "Get promo code", location });

  if (variant === "banner") {
    return (
      <div className="bg-gradient-to-r from-[#1E4FD8] to-[#0284C7] dark:from-[#1E4FD8] dark:to-[#0369A1] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-xs sm:text-sm">
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest">Limited-time offer</span>
          <span className="hidden sm:inline">Get an iViz promo code and use it when you sign up with your email.</span>
          <span className="sm:hidden">Get your iViz promo code.</span>
          <Link
            to="/promo"
            onClick={track}
            className="inline-flex items-center gap-1 font-semibold underline underline-offset-4 decoration-white/60 hover:decoration-white"
          >
            Get promo code <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-3xl border border-[#1E4FD8]/20 dark:border-[#4A90D9]/25 bg-gradient-to-br from-[#1E4FD8]/[0.08] via-white to-[#0284C7]/[0.06] dark:from-[#1E4FD8]/15 dark:via-[#0D0D10] dark:to-[#0284C7]/10 px-6 py-7 sm:px-8 sm:py-8">
      <div className="absolute -right-16 -top-20 h-48 w-48 rounded-full bg-[#1E4FD8]/10 blur-3xl" />
      <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#1E4FD8] text-white dark:bg-[#4A90D9] dark:text-[#050505]">
            <TicketPercent size={21} />
          </span>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#1E4FD8] dark:text-[#8CC0F0]">Limited-time iViz offer</p>
            <h2 className="mt-1.5 font-display text-2xl font-medium tracking-[-0.02em] text-[#0A0A0F] dark:text-white">Get your iViz promo code.</h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-[#5C5C66] dark:text-[#9A9A9A]">
              Enter your email and we&apos;ll send your code. Use the same email when you sign up for iViz.
            </p>
          </div>
        </div>
        <Link
          to="/promo"
          onClick={track}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#1E4FD8] px-6 py-3 text-sm font-medium text-white transition-transform hover:scale-[1.02] active:scale-[0.98] dark:bg-[#4A90D9] dark:text-[#050505]"
        >
          Get promo code <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
